// extracted by mini-css-extract-plugin
export default {"endorsers":"index_endorsers__vs3SC"};